import Title from '../components/title';
import Footer from '../components/footer';
import Subtitle from '../components/subtitle';
import Core from '../components/core';
import { ArrowLongDownIcon } from '@heroicons/react/20/solid'
import { ScrollRestoration } from "react-router-dom"

const navigation = [
    { id: 2, name: 'Bilans retraite', to: '/bilan-retraite/' , icon: ArrowLongDownIcon},
    { id: 3, name: 'Articulation chômage / retraite', to: '/articulation-chomage-retraite/' , icon: ArrowLongDownIcon},
    { id: 4, name: 'Des solutions d\'optimisation', to: '/solutions-optimisation/' , icon: ArrowLongDownIcon},
    { id: 5, name: 'Etudes comparatives expatriation', to: '/retour-expatriation/' , icon: ArrowLongDownIcon},
    { id: 6, name: 'Des conférences spécifiques', to: '/nos-conferences/' , icon: ArrowLongDownIcon},
    { id: 7, name: 'Liquidations de retraite', to: '/liquidations-retraite/' , icon: ArrowLongDownIcon},
]

const context = [
    {
        "title": <p className='text-lg leading-6 text-gray-600'>Que votre carrière se soit déroulée en France, à l'étranger ou sous différents régimes, Expertise & Benefits vous accompagne dans la préparation de votre dossier retraite.</p>,
        "core": [
            {
                "subtitle": "",
                "text": ""
            }
        ]
    },
    {
        "title": <h3 className="text-lg font-semibold leading-6 text-gray-900">Reconstitution de carrière :</h3>,
        "core": [
            {
                "subtitle": "",
                "text": <span>Analyse approfondie de votre parcours professionnel.</span>,
            },  
            {
                "subtitle": "",
                "text": <span>Obtention des relevés de trimestres: nous vous guidons dans les démarches pour obtenir les relevés de trimestres auprès de tous les régimes de base en France et à l'étranger, dans les pays avec ou sans convention avec la France.</span>,
            },
            {
                "subtitle": "",
                "text": <span>Information sur les dispositifs légaux en vigueur.</span>,
            },         
        ]
    },
    {
        "title": <h3 className="text-lg font-semibold leading-6 text-gray-900"> Optimisation de vos droits à la retraite :</h3>,
        "core": [
            {
                "subtitle": "",
                "text": <span>Etude personnalisée du rachat de trimestres : nous évaluons l'opportunité d'un rachat de trimestres pour atteindre le taux plein de la retraite Sécurité Sociale. Souvent onéreux, ces rachats doivent faire l'objet d'une étude d'opportunité, en vérifiant l'impact sur les autres régimes et l'avancement éventuel de l'ouverture des droits.</span>,
            },    
            {
                "subtitle": "",
                "text": <span>Validation des points de retraite complémentaire : nous pouvons, dans certains cas, recalculer le nombre de points au regard des bulletins de salaires et des cotisations.</span>,
            },        
        ]
    },    
]

export default function Recommandations() {
   

    return (
        <>

            <Title classNames="bg-strategie bg-cover lg:bg-right bg-left" title="Nos recommandations " />

            <Subtitle subtitle="Pour une stratégie retraite en France et à l'international" paragraph="Aborder de façon sereine les démarches administratives et optimiser vos droits à la retraite." />      

            <Core navigation={navigation} context={context} />         

            <Footer />

            <ScrollRestoration />
        </>
    )
}